import React from 'react';

import defaultPaths from '../translations/default-paths.json';
import { WebsiteLocaleFragment } from '../../graphql.schema';

export const PageContext = React.createContext({ pathPrefixes: defaultPaths , websiteLocale: {} as WebsiteLocaleFragment });
